export default __webpack_public_path__ + "media/images/react_icons/image-slider-512164d53e229565210e2540be98423a.svg";